import * as bg from 'url:../../../assets/images/icons/flags/bg.svg';
import * as en from 'url:../../../assets/images/icons/flags/en.svg';

export const languageFlagMap = { BG: bg, EN: en };
